import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

import { AddOnsSlice, createAddOnsSlice } from './add-ons.slice';
import { CompanySlice, createCompanySlice } from './company.slice';
import { FeaturesSlice, createFeaturesSlice } from './features.slice';
import { WorkflowSlice, createWorkflowSlice } from './workflow.slice';

/**
 * Define an interface describing the overall workspace store shape.
 */
export type IWorkspaceStore = AddOnsSlice & FeaturesSlice & WorkflowSlice & CompanySlice;

/**
 * Create the workspace store.
 */
export const useWorkspaceStore = create<IWorkspaceStore>()(
  devtools(
    immer((...args) => ({
      ...createAddOnsSlice(...args),
      ...createCompanySlice(...args),
      ...createFeaturesSlice(...args),
      ...createWorkflowSlice(...args),
    })),
    { name: 'Data Access | Workspace' }
  )
);
